import { memo } from 'react'

export default memo(function DownloadIcon(props: any) {
  return (
    <svg
      width={props.width ? props.width : '48px'}
      height={props.height ? props.height : '48px'}
      viewBox="0 0 48 48"
      fill={props.color ? props.color : '#888'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7925 32C24.1715 32 24.5504 31.8205 24.7399 31.5513L33.6448 23.2051C34.1184 22.7564 34.1184 22.0385 33.6448 21.5897C33.1711 21.141 32.4132 21.141 31.9396 21.5897L24.9293 28.141L24.9293 5.07692C24.9293 4.44872 24.3609 4 23.7925 4C23.2241 4 22.6557 4.53846 22.6557 5.07692L22.6557 28.2308L15.5508 21.5C15.0771 21.0513 14.3193 21.0513 13.8456 21.5C13.6561 21.6795 13.4667 22.0385 13.4667 22.3077C13.4667 22.5769 13.5614 22.8462 13.8456 23.1154L22.9399 31.7308C23.1294 31.9103 23.4136 32 23.7925 32Z"
        fill={props.color || '#888'}
      ></path>
      <path
        d="M42.6423 41.9375H5.25326C4.52219 41.9375 4 41.3375 4 40.7375C4 40.1375 4.62663 39.5375 5.25326 39.5375H42.7467C43.4778 39.5375 44 40.1375 44 40.7375C44 41.3375 43.3734 41.9375 42.6423 41.9375Z"
        fill={props.color || '#888'}
      ></path>
    </svg>
  )
})
